var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 51,
    viewBox: "0 0 55 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00506592,
    width: 54.9844,
    height: 51,
    rx: 6,
    fill: "#FC7100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.702 26.7071C41.0926 26.3166 41.0926 25.6834 40.702 25.2929L34.3381 18.9289C33.9476 18.5384 33.3144 18.5384 32.9239 18.9289C32.5333 19.3195 32.5333 19.9526 32.9239 20.3431L38.5807 26L32.9239 31.6569C32.5333 32.0474 32.5333 32.6805 32.9239 33.0711C33.3144 33.4616 33.9476 33.4616 34.3381 33.0711L40.702 26.7071ZM12.9949 27L39.9949 27V25L12.9949 25V27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.2ee2fe6dbb76af0bc1da9cad1dcf9397.svg";
export { ForwardRef as ReactComponent };